import Content1 from "../../../assets/images/projects/contextual-voucher/Content1.png";
import Content2 from "../../../assets/images/projects/contextual-voucher/Content2.png";
import Content3 from "../../../assets/images/projects/contextual-voucher/Content3.png";
import Content4 from "../../../assets/images/projects/contextual-voucher/Content4.png";
import Content5 from "../../../assets/images/projects/contextual-voucher/Content5.png";

import { ProjectDetailProps } from "../props";

export default {
  title: "Contextual Voucher",
  timeline: "",
  context:
    "A curated promo section that offers promo code that eligible for user packed in design thinking storytelling.",
  team: [
    "Freddy Albert Sanjaya - UX designer",
    "Okky & Jessica - UI designer",
    "Clara P - UX copywriter",
    "Alfandio Grasheldi - UX researcher",
  ],
  thumbnail: "",
  contents: [
    {
      left: {
        title: "Background",
        content: (
          <div>
            In Blibli Checkout we emphasize the important of the droprate since
            last purchasing decision will be determine here. It's obviously
            become a paramount for ecommerce and there are many factor includes
            in this purchasing gate. And so by that, data, research, and
            validation from user are very crucial to help us decide the best
            feature to build and solve the real problem instead of the guts or
            'one-sided perspective.'
            <p>
              According to the Baymard research and our validation research,
              there are several risks on why customer drop at Checkout:
            </p>
            <li>Shipping fee (free/not)</li>
            <li>Encounter promo error</li>
            <li>Slow delivery</li>
            <li>No preferences payment choice*</li>
            <p>
              Aligning with our Checkout condition we try to observe on how we
              can decrease the drop rate from Checkout. Using{" "}
              <strong>design thinking</strong> storytelling approach helps to
              string the design process and forms a strong/agile product that
              can be iterated over times. Also a voucher/promo kind of thing
              seems to be really simple, yet in here I am going to share '(not
              so) secret' information on how this tiny promo looks can be
              crucial for users and how is the impact of this promo.
              <p>
                (Disclaimer: I am trying to share the most proper way to
                communciate and still protect the confidential information)
              </p>
            </p>
            <p>
              This flow chart depicted the overview process of the design
              thinking approach on this project:
            </p>
          </div>
        ),
      },
      bottomImage: Content1,
    },
    {
      left: {
        title: "Empathize & Define",
        content: (
          <div>
            The initial project usually comes from Product Manager. On this
            particular project he showed the data on how the error occured in
            promo checkout that impact the droprate. Therefore, with purposing a
            rough features had become something that we looked up and explored.
            In this state, I dived deeply to the requirements and broadened the
            view for scoping the project. Not to mention exploring the user's
            behaviour and findings in research such as competitive analyst and
            user's journey (benchmark) to gain more insights is necessary.
            <p>
              <p>
                {" "}
                We have managed to identify the problems after compiling the
                insights
              </p>
              <li>
                Lack of understanding from user about the eligiblity of the
                promo code when they submit the code
              </li>
              <li>
                The promo amount, placement, and detail information for user to
                know about the promo code before they perceive the voucher
              </li>
              <li>
                The entry point of the user on where they can copy and apply
                promo code are unraveling since many promo codes are not valid
                anymore.
              </li>
              <li>
                Many usecases of promos in Blibli that might confused the user:
                promo types, reward types, promo levels/layering/tiering, promo
                priorities and the terms and condition in Discount, Cashback,
                and Blibli Rewards Points promo.
              </li>
            </p>
          </div>
        ),
      },

      bottomImage: "",
    },
    {
      left: {
        title: "Ideate",
        content: (
          <div>
            <p>
              The question that brought and discussed turned into one big
              question on how might we show all of the promo types for customers
              in layering/leveling that easily to understand.
              <p>
                The compability of promo types, naming and terms and condition
                information, ordering in the vouchers are something that
                included on the consideration of making the features quite
                easier. In here, we improved and mapping on the systems so we
                can show the relevant inforamtion needed also created it from
                wireframe to handover it with the UI Designer. The visuals in
                here are an assessed looks from the UI Designer (see the pic)
              </p>
            </p>
          </div>
        ),
      },
      right: {
        title: "",
        content: <img alt="" src={Content2} width="100%" />,
      },
      bottomImage: "",
    },
    {
      left: {
        title: "Prototype",
        content: (
          <div>
            <p>
              Little did we know, interaction seems to be one of the
              consideration of promo code sectioning. A quick internal user
              testing (4/5 people) beforehand and asking preferences how they
              perceived this contextual voucher promo code gave a view on how we
              can depict it in Checkout promo.
            </p>
            We discovered on how we can depict the voucher information and to
            improve the voucher section. Developed and finalized with the
            current visual voucher, this is the final looks on the contextual
            voucher or can be called as Recommended Voucher.
          </div>
        ),
      },
      right: {
        title: "",
        content: <img alt="" src={Content3} width="100%" />,
      },
      bottomImage: "",
    },

    {
      left: {
        title: "Iterate",
        content: (
          <div>
            We did evaluation research for this feature after built it and track
            the awareness and feedback from users. The research results are
            pretty good, people feel this features help them to use
            automatically rather than copy it first for the continous
            purchasing. And with all that we iterate and track the promo
            concerns.
            <p>
              To sum up, we have done improvements from time to time to:
              <li>
                Add it to Product Detail Page for discovering the products that
                have the potential promo to be used{" "}
              </li>
              <li>
                Add it to be more contextual in promotion page and in all promo
                page (give the context of the quota and time urgency)
              </li>
              <li>
                Improve specific information for particular promo in
                payment/channel with image URL
              </li>
              <li>Improve the personalized contextual from the user's habit</li>
            </p>
            <p>
              The impact of this feature is shown by error promo was reduced and
              the Checkout drop rate significantly decreased which is the top
              decreasing of the drop rate in Checkout.
            </p>
          </div>
        ),
      },
      bottomImage: Content4,
    },

    {
      left: {
        title: "Additional notes",
        content: (
          <div>
            On reducing the time and increase effectivity work, I created
            components that will help all of designers that use this component
            vouchers and promo coupon. And we were about improving the
            components to be inputted in the Design System in Blibli per
            November 2021. The reason of doing all these also includes to make
            consistency in all across platform.
          </div>
        ),
      },
      bottomImage: Content5,
    },
  ],
} as ProjectDetailProps;
